import { Col, Row } from "reactstrap";

export const BreadCrumb = ({ title, pageTitle }) => {
  return (
    <div className="mb-4">
      <Row className="align-items-center">
        <Col>
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-0">{title}</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">{pageTitle}</li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};